<template>
  <div>
    <div class="pub-head">
      <div class="pub-head-icon">
        <img src="/images/publish-2.svg" class="pub-head-icon-img" />
      </div>
      <div class="pub-head-text">
        <div class="pub-heading">{{ service.title }}</div>
      </div>

      <div class="clearfix"></div>

      <div class="pub-heading-included">
        <div class="pub-heading-included-heading">What's included</div>

        <template v-if="service.name === 'ad-copy'">
          <div class="pub-heading-included-item">
            &bull; &nbsp;3 distinct ad copy options that you can use to start or
            optimize an Amazon Ad Campaign.
          </div>
          <div class="pub-heading-included-item">
            &bull; &nbsp;A short how-to video showing you how to add and edit
            your ad copy on Amazon.
          </div>
          <div class="pub-heading-included-item">
            &bull; &nbsp;Your ad copy options will be emailed to you.
            <span style="font-weight: 700">
              Please allow 4 business days for us to complete your request and
              email you. You will receive your bonus snaps immediately.
            </span>
          </div>
        </template>

        <template v-if="service.name === 'product-description'">
          <div class="pub-heading-included-item">
            &bull; &nbsp;A full and formatted product description for your
            Amazon book listing that is based on our research of your book
            and audience.
          </div>
          <div class="pub-heading-included-item">
            &bull; &nbsp;A short how-to video showing you how to edit your
            product description on Amazon.
          </div>
          <div class="pub-heading-included-item">
            &bull; &nbsp;Your product description will be emailed to you.
            <span style="font-weight: 700">
              Please allow 4 business days for us to complete your request and
              email you. You will receive your bonus snaps immediately.
            </span>
          </div>
        </template>

        <template v-if="service.name === 'adword-keywords'">
          <div class="pub-heading-included-item">
            &bull; &nbsp;A spreadsheet of 200 keywords and bid prices that you
            can upload directly into AMS easily.
          </div>
          <div class="pub-heading-included-item">
            &bull; &nbsp;A short how-to video showing you how to upload your
            spreadsheet into AMS.
          </div>
          <div class="pub-heading-included-item">
            &bull; &nbsp;Your spreadsheet will be emailed to you.
            <span style="font-weight: 500">
              Please allow 4 business days for us to complete your request and
              email you. You will receive your bonus snaps immediately.
            </span>
          </div>
        </template>

        <template v-if="service.name === 'kdp-keywords'">
          <div class="pub-heading-included-item">
            &bull; &nbsp;7 keywords and 2 categories tailored for your book
            based on our research of your book and audience.
          </div>
          <div class="pub-heading-included-item">
            &bull; &nbsp;A short how-to video showing you how to add and edit
            your KDP keywords and categories on Amazon.
          </div>
          <div class="pub-heading-included-item">
            &bull; &nbsp;Your 7 keywords and 2 categories will be emailed to
            you.
            <span style="font-weight: 700">
              Please allow 4 business days for us to complete your request and
              email you. You will receive your bonus snaps immediately.
            </span>
          </div>
        </template>
      </div>
    </div>

    <div
      class="pub-section"
      :class="{
        'pub-section-completed': sections.chooseBook.status === 'Completed',
      }"
    >
      <div class="heading then-cardlist heading-top">Choose Book</div>
      <div class="heading-check">
        <i class="material-icons check-icon">check_circle</i>
      </div>
      <div class="pub-steps pub-steps-current">
        <div class="pub-steps-step">Step</div>
        <div class="pub-steps-current">1</div>
        <div class="pub-steps-of">of</div>
        <div class="pub-steps-total">3</div>
      </div>
      <div class="clearfix"></div>

      <div class="pub-heading-instructions">
        Choose which of your books you would like the {{ service.title }} for.
      </div>

      <div class="selected-book-label" v-if="bookId">Selected Book</div>

      <div
        v-for="oneBook in books"
        :key="oneBook.id"
        @click="clickBook(oneBook)"
      >
        <card
          :book="oneBook"
          :locked="true"
          v-if="!bookId || bookId === oneBook.id"
        ></card>
      </div>

      <!-- <div class="continue-button action" @click="clickContinue('chooseBook')">Continue</div> -->
    </div>
    <div
      class="pub-section"
      v-if="sections.addMessage.status !== 'Waiting'"
      :class="{
        'pub-section-completed': sections.addMessage.status === 'Completed',
      }"
    >
      <div class="heading then-cardlist heading-top">Add Message</div>
      <div class="heading-check">
        <i class="material-icons check-icon">check_circle</i>
      </div>

      <div class="pub-steps pub-steps-pending">
        <div class="pub-steps-step">Step</div>
        <div class="pub-steps-current">2</div>
        <div class="pub-steps-of">of</div>
        <div class="pub-steps-total">3</div>
      </div>
      <div class="clearfix"></div>

      <div class="pub-heading-instructions">
        Kristen does a comprehensive review of your current Amazon listing
        and your book's manuscript before starting her work.
        <br />
        <br />Please provide any additional information or notes about your book
        or audience below that might be helpful to supplement her own research.
        (Optional)
      </div>

      <textarea
        class="prompt-answer"
        style="height: 140px"
        v-model="serviceMessage"
      ></textarea>

      <div
        class="continue-button action"
        v-if="sections.addMessage.status !== 'Completed'"
        @click="clickContinue('addMessage')"
      >
        Continue
      </div>
    </div>
    <div class="pub-section pub-section-pending" v-else>
      <div class="heading then-cardlist heading-top">Add Message</div>
      <div class="pub-steps pub-steps-pending">
        <div class="pub-steps-step">Step</div>
        <div class="pub-steps-current">2</div>
        <div class="pub-steps-of">of</div>
        <div class="pub-steps-total">3</div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="pub-section" v-if="sections.choosePrice.status !== 'Waiting'">
      <div class="heading then-cardlist heading-top">Review & Confirm</div>
      <div class="pub-steps pub-steps-pending">
        <div class="pub-steps-step">Step</div>
        <div class="pub-steps-current">3</div>
        <div class="pub-steps-of">of</div>
        <div class="pub-steps-total">3</div>
      </div>
      <div class="clearfix"></div>

      <div class="pub-option-pricing-container">
        <div class="pub-option-pricing">
          <div class="pub-option-price">
            <div class="pub-option-price-label snaps-label">Snaps Bonus</div>
            <div class="pub-option-price-number">
              <div class="points-container">
                <div class="points-icon">
                  <img src="/images/icons/snap.svg" class="points-icon-img" />
                </div>

                <div class="points">
                  {{ service.max_snap_cost | bigNumber }}
                </div>
              </div>
            </div>
          </div>

          <div class="pub-option-price">
            <div class="pub-option-price-label member-label">Your Price</div>
            <div class="pub-option-price-number">
              ${{ Math.round(service.price) }}
            </div>
          </div>

          <div class="pub-option-price">
            <div class="pub-option-price-label">Agency Price</div>
            <div class="pub-option-price-number number-agency">
              ${{ service.max_price }}
            </div>
          </div>

          <div class="clearfix"></div>
        </div>
      </div>

      <div class="confirm-book">
        Selected Book:
        <span class="confirm-book-title">{{
          book.title | shortBookTitle
        }}</span>
      </div>

      <div
        class="promote-option-pay"
        v-if="paymentMethod"
        :class="{ 'hidden-o': !price }"
      >
        <div class="payment-line">
          Your
          {{ paymentMethod.card_brand }} card ending in
          <span style="font-weight: 600">{{
            paymentMethod.card_last_four
          }}</span>
          will be charged
          <span style="font-weight: 600">${{ price }}.</span>

          <p>
            You will receive
            <span style="font-weight: 600"
              >{{ snapsCost | bigNumber }} snaps</span
            >
            immediately.
          </p>
          <p style="padding-top: 12px; padding-bottom: 0; margin-bottom: 0">
            Your {{ service.title }} will be delivered to you via email.
            <span style="font-weight: 700">
              Please allow 4 business days for us to complete your request and
              email you. You will receive your bonus snaps immediately.
            </span>
          </p>
        </div>
        <div @click="clickConfirm" class="payment-button payment-button-later">
          Confirm Payment
        </div>
        <!-- <div @click="cancelPayNow" class="payment-button payment-button-cancel">Cancel</div> -->
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="pub-section pub-section-pending" v-else>
      <div class="heading then-cardlist heading-top">Review & Confirm</div>
      <div class="pub-steps pub-steps-pending">
        <div class="pub-steps-step">Step</div>
        <div class="pub-steps-current">3</div>
        <div class="pub-steps-of">of</div>
        <div class="pub-steps-total">3</div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import ServiceOption from "@/components/Publish/ServiceOption";

import Head from "@/components/Page/Head";
import Heading from "@/components/Page/Heading";
import List from "@/components/Book/List";
import Card from "@/components/Book/Card";
import Back from "../modules/Back";
import Bus from "../modules/Bus";
import PriceSlider from "@/components/Publish/PriceSlider";
import { mapState } from "vuex";

export default {
  name: "AddPublishPage",
  components: {
    Head,
    Heading,
    ServiceOption,
    Card,
    PriceSlider,
  },
  computed: {
    ...mapState({
      user: "user",
      books: "books",
      events: "events",
    }),
  },
  data: function () {
    return {
      serviceName: this.$route.params.name || null,
      book: null,
      bookId: null,
      service: null,
      serviceMessage: null,
      isWorking: false,
      price: null,
      snapsCost: null,
      paymentMethod: null,
      sections: {
        chooseBook: {
          id: "chooseBook",
          status: "Editing",
          next: "addMessage",
        },
        addMessage: {
          id: "addMessage",
          status: "Waiting",
          next: "choosePrice",
        },
        choosePrice: {
          id: "choosePrice",
          status: "Waiting",
          next: null,
        },
      },
    };
  },
  async created() {
    this.service = await Back.publishService(this.serviceName);

    const result = await this.getUserPaymentMethod();

    this.price = this.service.price;
    this.snapsCost = this.service.max_snap_cost;
  },
  methods: {
    clickBook(book) {
      console.log("ap click book");
      this.book = book;
      this.bookId = book.id;
      this.clickContinue("chooseBook");
    },
    clickContinue(sectionName) {
      const section = this.sections[sectionName];

      if (!this.validateSection(sectionName)) {
        return;
      }

      if (!this.finishSection(sectionName)) {
        return;
      }

      this.sections[sectionName].status = "Completed";

      if (section.next) {
        this.sections[section.next].status = "Editing";
        // console.log("ap next", this.sections[section.next]);
      }
    },
    async clickConfirm() {
      if (this.isWorking) {
        return;
      }

      try {
        this.isWorking = true;
        var element = document.createElement("div");
        element.setAttribute("id", "loadingOverlay");
        document.body.appendChild(element);

        const response = await Back.submitPublishJob({
          book_id: this.book.id,
          publish_service_id: this.service.id,
          message: this.serviceMessage,
          snaps_bonus: this.snapsCost,
        });

        // console.log("response", response);

        if (response && response.stripe_id) {
          this.$router.push("/publish");
          this.$toasted.show("Great! Your order has been placed.", {
            icon: "check_circle",
            position: "bottom-center",
            duration: 3000,
          });
          Bus.$emit("UserChanged", this.book);
        } else {
          this.$toasted.show(
            "Oops! Something went wrong with your payment method. Please contact our support team or try again later.",
            {
              icon: "error",
              position: "bottom-center",
              duration: 3000,
            }
          );
        }

        document.getElementById("loadingOverlay").outerHTML = "";
        this.isWorking = false;
      } catch (err) {
        document.getElementById("loadingOverlay").outerHTML = "";
        this.isWorking = false;
      }

      //console.log("clickConfirm", response);
    },
    validateSection(section) {
      return true;
    },
    finishSection(section) {
      return true;
    },
    onPriceChange(value, snapsCost) {
      this.price = value;
      this.snapsCost = snapsCost;
      console.log("onPriceChange", this.price);
    },
    async getUserPaymentMethod() {
      const response = await Back.userPaymentMethod();

      if (!response) {
        this.$toasted.show(
          "Your payment method could not be found. Please contact our support team or try again later.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 4000,
          }
        );
      }

      this.paymentMethod = response;

      // console.log("getUserPaymentMethod", response);
    },
  },
};
</script>

<style scoped lang="scss">
.pub-head {
  max-width: 560px;
  margin: 0 auto;
  padding-top: 12px;
  padding-bottom: 44px;
}
.pub-head-icon {
  float: left;
  width: 100px;
  margin-left: 0px;
}
.pub-head-text {
  float: left;
  width: 400px;
}
.pub-head-icon-img {
  width: 68px;
  margin: 46px 0 0 0;
}

.pub-heading {
  padding: 58px 0 2px 0;
  text-align: left;
  font-size: 21pt;
  font-weight: 600;
  font-family: $font-family;
}
.pub-subheading {
  text-align: left;
  font-size: 14.5pt;
  font-weight: 500;
  font-family: $font-family;
}

.pub-heading-included {
  border-top: 1px solid #e4e4e4;
  border-bottom: 1px solid #e4e4e4;
  padding-bottom: 16px;
}
.pub-heading-included-heading {
  margin-bottom: 8px;
  padding-top: 14px;
  padding-bottom: 11px;
  border-bottom: 1px solid #e4e4e4;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 12pt;
  font-weight: 600;
  color: #111;
}
.pub-heading-included-item {
  font-family: $font-family;
  font-size: 12pt;
  padding: 6px 40px;
}

.selected-book-label {
  padding: 12px 0 12px 0;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 12pt;
  font-weight: 700 !important;
  color: $color-blue;
  font-family: $font-family;
}

.pub-section {
  width: 600px;
  margin: 40px;
  margin-bottom: 60px;
  margin-top: 0px;
  margin-left: auto;
  margin-right: auto;
}

.pub-section-heading {
  padding: 20px 0 16px 0;
  text-align: center;
  font-size: 21pt;
  font-weight: 600;
  font-family: $font-family;
}

.pub-heading-instructions {
  padding: 12px 0 12px 0;
  color: #222;
  text-align: left;
  font-size: 13pt;
  font-weight: 500;
  font-family: $font-family;
}
.pub-heading-instructions-second {
  padding: 12px 0 12px 0;
  color: #555;
  text-align: left;
  font-size: 12.5pt;
  font-weight: 500;
  font-family: $font-family;
}

.confirm-book {
  padding: 0px 80px;
  font-size: 12.5pt;
  font-family: $font-family;
  font-weight: 600;
}
.confirm-book-title {
  font-weight: 600;
  color: $color-blue;
}

.heading {
  float: left;
}

.heading-check {
  float: left;
  margin-top: 10px;
  margin-left: 6px;
  opacity: 0;
}

.pub-steps {
  float: right;
  margin: 0px 8px;
  padding-top: 8px;
  padding-left: 20px;
  padding-bottom: 12px;
  display: flex;
  font-family: $font-family;

  .pub-steps-step {
    padding: 0 12px 0 0;
    padding-top: 3px;
    font-size: 12pt;
    font-weight: 500;
    color: #111;
  }

  .pub-steps-current {
    width: 32px;
    height: 32px;
    border-radius: 32px;
    background: $color-blue;
    padding-top: 2px;
    font-size: 14pt;
    font-weight: 600;
    color: #fff;
    text-align: center;
  }

  .pub-steps-of {
    padding: 0 12px 0 12px;
    padding-top: 3px;
    font-size: 12pt;
    font-weight: 500;
    color: #111;
  }

  .pub-steps-total {
    padding: 0 12px 0 0px;
    padding-top: 0px;
    font-size: 15pt;
    font-weight: 500;
    color: #111;
  }
}

.pub-section-pending {
  opacity: 0.4;
  margin-bottom: 20px;
  margin-top: 0px;

  .pub-steps-pending {
    .pub-steps-current {
      background: #aaa !important;
    }
  }
}

.pub-section-completed {
  .pub-steps {
    .pub-steps-current {
      background: lighten($color-blue, 0%) !important;
    }
  }

  .heading-check {
    opacity: 1;
  }
}

.check-icon {
  color: lighten($color-blue, 0%) !important;
}

.pub-options {
  margin: 40px 0;
  border-top: 2px solid #eee;
  font-family: $font-family;
}

.content-container {
  max-width: 1000px !important;
  margin-left: 4px;
  border-bottom: 0;
}

.content-challenges {
  max-width: 100% !important;
  border-top: 2px solid #eee;
  //padding-top: 20px;
}
.column-challenges {
  max-width: 710px;
}

.section-divider {
  width: 100%;
  height: 40px;
}

.add-book {
  display: block;
  margin: 0 auto;
  width: 200px;
  height: 52px;
  border-radius: 52px;
  border: 1px solid #ddd;
}
.add-icon {
  float: left;
  width: 32px;
  margin: 0px 0 0 32px;
  font-size: 26pt;
  text-align: center;
  color: #2196f3;
}
.add-label {
  float: left;
  width: 120px;
  margin: 10px 0 0 6px;
  font-size: 15pt;
  font-weight: 600;
  color: #2196f3;
  font-family: "Source Sans Pro";
}

.add-book:hover {
  box-shadow: 0 0 0.3rem rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: scale(1.05);
}
.grow {
  transition: all 0.1s ease-in-out;
}
.grow:hover {
  transform: scale(1.03);
}

.activity-col {
  padding-left: 2px;
  max-width: 710px;
  margin: 20px 0;
}

.continue-button {
  background: #daedff;
  color: #2196f3;
}

.prompt-answer {
  width: 100%;
  max-width: 740px;
  outline: 0;
  margin-bottom: 12px;
  border: 3px solid #fff;
  border: 2px solid #f4f4f4;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 14pt;
  font-family: $font-family;
}

.payment-line {
  border-top: 1px solid #e3e3e3;
  border-bottom: 1px solid #e3e3e3;
  margin: 16px 80px 16px 80px;
  padding: 12px 0 16px 0;
  font-size: 12pt;
  font-weight: 500;
  color: #111;
  font-size: 12pt;
  font-family: $font-family;
}
.payment-line p {
  margin: 0.75em 0 0 0;
  padding-top: 0 !important;
}

.payment-button {
  float: none;
  font-family: $font-family;
  width: 174px;
  margin-right: 0px;
  margin-left: 192px;
  font-size: 13pt;
  font-weight: 600;
  background: darken($color-blue, 4%);
  background: linear-gradient(
    0deg,
    $color-blue 0%,
    lighten($color-blue, 13%) 100%
  );
  border-radius: 4px;
  border: 2px solid darken($color-blue, 4%);
  border-bottom: 2px solid darken($color-blue, 7%);
  color: #fff;
  padding: 6px 18px;
  padding-top: 5px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  text-shadow: 2px 2px 1px rgba(17, 17, 17, 0.25);
  text-align: center;
  cursor: pointer;
}
.payment-button:hover {
  background: linear-gradient(
    0deg,
    darken($color-blue, 8%) 0%,
    lighten($color-blue, 5%) 100%
  );
}

.hidden-o {
  opacity: 0;
}

@media (max-width: 1024px) {
  .add-book-container {
    padding-bottom: 20px;
  }

  .activity-col {
    padding-left: 0;
  }
}

// Publish pricing options

.pub-option-pricing-container {
  margin: 20px 60px 20px 40px;
  border: 1px solid #e3e3e3;
  padding-top: 12px;
  font-family: $font-family;
  border-radius: 4px;
}

.pub-option-pricing {
  padding: 0px;
  padding-bottom: 16px;
  // padding-left: 50px;
  // width: 350px;
  // margin: 0 auto;
}

.pub-option-price {
  float: right;
  width: 150px;
}
.pub-option-price-label {
  font-size: 10.5pt;
  text-transform: uppercase;
  color: #666;
}
.pub-option-price-number {
  font-size: 13.5pt;
  font-weight: 600;
  text-transform: uppercase;
  color: #111;
}

.number-agency {
  text-decoration: line-through;
  color: #666 !important;
}

.member-label {
  color: darken(#e08d00, 4%);
}
.snaps-label {
  color: darken(#e08d00, 4%);
}

// Points Tag
.points-container {
  display: flex;
  justify-content: left;
  border-radius: 28px;
  padding: 3px 0 0 0;
  margin-left: -2px;
  margin-top: -1px;
}
.border {
  border: 2px solid darken($color-sidebar, 4%) !important;
}
.points-icon {
  flex-grow: 0;
  padding-top: 0px;
  margin-top: -1px;
}
.points-icon-img {
  width: 22px;
  color: $color-snaps;
  font-size: 18pt !important;
}
.points {
  flex-grow: 0;
  color: darken($color-snaps, 0%);
  margin-left: 5px;
  font-size: 13pt !important;
  font-weight: 600;
  font-family: "Source Sans Pro";
}
</style>